var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttachmentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 24,
    viewBox: "0 0 15 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 11.12 17.8842 C 10.7116 17.8842 10.3804 17.5926 10.3804 17.2326 V 6.1567 C 10.3804 4.0011 8.3898 2.2475 5.943 2.2475 C 3.4963 2.2475 1.5057 4.0011 1.5057 6.1567 V 13.9751 C 1.5057 15.4121 2.8328 16.5812 4.464 16.5812 C 6.0952 16.5812 7.4223 15.4121 7.4223 13.9751 L 7.4221 6.1567 C 7.4221 5.4381 6.7587 4.8537 5.943 4.8537 C 5.1275 4.8537 4.464 5.4381 4.464 6.1567 V 13.9751 C 4.464 14.3348 4.133 14.6267 3.7244 14.6267 C 3.3159 14.6267 2.9848 14.335 2.9848 13.9751 V 6.1567 C 2.9848 4.7196 4.3119 3.5505 5.943 3.5505 C 7.5742 3.5505 8.9013 4.7196 8.9013 6.1567 V 13.9751 C 8.9013 16.1306 6.9108 17.8842 4.464 17.8842 C 2.0172 17.8842 0.0267 16.1306 0.0267 13.9751 V 6.1567 C 0.0267 3.2826 2.6808 0.9445 5.943 0.9445 C 9.2054 0.9445 11.8593 3.2828 11.8593 6.1567 V 17.2326 C 11.8593 17.5925 11.5282 17.8842 11.1198 17.8842 H 11.12 Z",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentIcon);
export default __webpack_public_path__ + "static/media/attachmentIcon.691868ca.svg";
export { ForwardRef as ReactComponent };